import React, { useState } from 'react';
import PropTypes from 'prop-types';
import s from './Accordion.scss';

const Accordion = props => {
  const { data, onChange, isMweb } = props;

  const initialAcc = {};
  for (let i = 0; i < data.length; i += 1) {
    if (i === 0) {
      initialAcc[i + 1] = true;
    } else {
      initialAcc[i + 1] = false;
    }
  }

  const [openAcc, updateAccordianState] = useState(initialAcc);

  const toggleAccordian = accordianKey => {
    const openAccNew = { ...openAcc };
    openAccNew[accordianKey] = !openAccNew[accordianKey];
    updateAccordianState(openAccNew);
    if (typeof onChange === 'function') {
      onChange();
    }
  };

  if (!data || !Array.isArray(data) || !data.length) {
    return null;
  }

  return (
    <div className={s.accordion}>
      {data.map((accordian, index) => (
        <div>
          <div
            className={`${
              openAcc[index + 1] ? s.openAccordion : s.closeAccordion
            }`}
            key={index + 1}
          >
            <div
              className={s.accordionHeading}
              onClick={() => {
                toggleAccordian(index + 1);
              }}
            >
              <div className={s.accordionBtn}>
                <div className={s.storySeq}>
                  {/* <span>{index + 1}. </span> */}
                  {accordian.headline}
                </div>
                {isMweb && (
                  <div
                    className={`${
                      openAcc[index + 1] ? s.arrowUp : s.arrowDown
                    }  ${s.accordionMobileIcon}`}
                  />
                )}
                {!isMweb && (
                  <div className={s.accordionIcon}>
                    {openAcc[index + 1] ? (
                      <img
                        className={s.accordionToggleDot}
                        src="https://static.toiimg.com/photo/91805880.cms"
                        alt=""
                      />
                    ) : (
                      <img
                        className={s.accordionToggleDot}
                        src="https://static.toiimg.com/photo/91805887.cms"
                        alt=""
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className={s.accContent}>{accordian.content}</div>
          </div>
          {accordian.nonaccContent &&
            accordian.nonaccContent.length > 0 && (
              <div className={s.inlineContent}>{accordian.nonaccContent}</div>
            )}
        </div>
      ))}
    </div>
  );
};

Accordion.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  isMweb: PropTypes.bool,
  onChange: PropTypes.func,
};

Accordion.defaultProps = {
  data: [],
  isMweb: false,
  onChange: () => {},
};

export default Accordion;
